import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import modal from '@/app/components/Common/Modal.vue'
import VueHead from 'vue-head'
import { Chrome } from 'vue-color'
import VueCookies from 'vue-cookies'
import { quillEditor } from 'vue-quill-editor'
import VueMeta from 'vue-meta'

/* bootstrap */
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

/* googlemaps */
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueCookies)

Vue.use(BootstrapVue)
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_ACCESS_TOKEN,
    libraries: 'places,geometry,drawing'
  }
})

Vue.use(VueHead)
Vue.use(Chrome)
Vue.use(quillEditor)
Vue.use(VueMeta)

/* service worker */
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        // 登録成功
        // 変更があれば更新する
        registration.onupdatefound = function () {
          registration.update()
        }
      })
      // 登録失敗
      .catch(e => console.log('error', e))
  })
}

/* globalcom */
Vue.component('modal', modal)
Vue.config.productionTip = false

// templateで使用するためのグローバル変数を定義する
const GlobalData = new Vue({
  data: {
    $header_title: process.env.VUE_APP_HEADER_TITLE
  }
})

// mixin でグローバル変数をラッピングする
Vue.mixin({
  computed: {
    // 各コンポーネント内の<template>タグ内でグローバル変数を参照するための処置
    $header_title: {
      get: function () { return GlobalData.$data.$header_title },
      set: function (newTitle) { GlobalData.$data.$header_title = newTitle }
    }
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
